import actions from './actions';
import getters from './getters';
import mutations from './mutations';

/**
 * Register module state.
 *
 * @returns {object} Register state.
 */
const state = () => ({
    // state
    isRegistering: false,
    transitionEnabled: true,
    recentlyRegistered: false,
    // steps
    step: 1,
    previousStep: 0,
    stepsCount: 3,
    // data
    data: {},
    errors: {},
});

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
